import { SelecaoCompraGiro } from "@/components/CompraRapidaGiro";
import { FinalizarCompraSorteioGiroDto } from "@/dtos/Request/FinalizarCompraSorteioGiroDto";

type PayloadBase = Omit<
    FinalizarCompraSorteioGiroDto,
    "Qtd" | "IdPacotePromocional" | "QtdPacotePromocional"
>;

export function montarPayloadSorteioGiro(
    selecao: SelecaoCompraGiro,
    base: PayloadBase
): FinalizarCompraSorteioGiroDto {
    if (selecao.modo === "pacote") {
        return {
            ...base,
            Qtd: 0,
            IdPacotePromocional: selecao.idPacotePromocional,
            QtdPacotePromocional: 1,
        };
    }

    return {
        ...base,
        Qtd: selecao.quantidade,
    };
}
